module.exports = __webpack_public_path__ + "img/icon-ok.432191be.svg";